<template>
  <div>
    <v-img alt="" contain class="page-header" src="@/assets/redcar/page-headers/who-can-help.png" />
    <div class="items-wrapper">
      <OrganisationItem
          :key="organisation.id"
          v-for="organisation in organisations"
          :organisation = organisation
      />
    </div>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import OrganisationItem from '@/components/Organisations/OrganisationItem.vue';

export default {
  name: "Organisations",
  components: {
    OrganisationItem
  },
  computed: {
    organisations() {
      return hubbdata.state.organisations
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
  }
}
</script>

<style lang="scss">
.organisation__link {
  text-decoration: none !important;

  .v-card__actions {
    @media (max-width: 576px) {
      display: flex;
      justify-content: center;
    }

    @media (min-width: 577px) {
      margin-left: 8px;
    }

    .email {
      width: 165px;
      white-space: normal;
    }

    .v-btn--outlined {
        background-color: #4f3b97;
        color: white!important;
        font-weight: 18px;
        margin: 0 auto;
        font-weight: bold;
    }
  }

  .headline p {
    white-space: pre-wrap;
    font-size: 22px !important;
    margin-right: 60px;
  }

  .v-icon {
    color: white;
    font-size: 40px;
  }
}
</style>